import { render, staticRenderFns } from "./p_list.vue?vue&type=template&id=626769f0"
import script from "./p_list.vue?vue&type=script&lang=ts"
export * from "./p_list.vue?vue&type=script&lang=ts"
import style0 from "./p_list.vue?vue&type=style&index=0&id=626769f0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports